'use client';

import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

type OriginalPlusApplicationSuccessModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

export function OriginalPlusApplicationSuccessModal({
  open,
  onOpenChange,
}: OriginalPlusApplicationSuccessModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-[90%] max-w-[400px] rounded-3xl bg-white sm:rounded-3xl">
        <DialogHeader className="items-center text-center">
          <DialogTitle className="text-center text-xl font-semibold leading-6 text-[#1B1D22]">
            Заявка успешно оформлена
          </DialogTitle>
          <DialogDescription className="mt-2 text-center text-[#6E7384]">
            Заявка отправлена. Команда Molwe посмотрит твой текст и свяжется с тобой для короткой
            консультации и подбора подходящего формата участия
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="relative z-[60] !justify-center">
          <Button
            type="button"
            onClick={() => onOpenChange(false)}
            className="w-full rounded-xl bg-[#505CFF] px-3 py-4 text-white hover:bg-[#505CFF]/80"
          >
            Понятно
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
